module.exports = __webpack_public_path__ + "img/discover-icon-02.d16dc570.svg";